// LUMINA · components/EnergyTierGate.jsx
// Phase 58: Paywall / trial-gate for daily energy features

import React from 'react';

const GD = "#D4AF37";

export default function EnergyTierGate({ daysLeft, onUpgrade }) {
  const inTrial = typeof daysLeft === "number" && daysLeft > 0;

  return (
    <div style={{
      background: "linear-gradient(135deg,rgba(212,175,55,0.06),rgba(139,105,20,0.10))",
      border: "1.5px solid rgba(212,175,55,0.35)",
      borderRadius: 14, padding: "24px 28px", textAlign: "center",
    }}>
      {inTrial ? (
        <>
          <div style={{ fontSize: 11, color: GD, letterSpacing: 3, marginBottom: 8, textTransform: "uppercase" }}>
            澄光日课 · 免费体验
          </div>
          <div style={{ fontSize: 28, color: GD, fontWeight: 700, marginBottom: 4,
            fontFamily: "'Inter',sans-serif" }}>{daysLeft}</div>
          <div style={{ fontSize: 12, color: "rgba(0,0,0,0.45)", marginBottom: 16, letterSpacing: 1 }}>
            天体验剩余
          </div>
          <div style={{ fontSize: 13, color: "rgba(0,0,0,0.55)", marginBottom: 20, lineHeight: 1.7 }}>
            体验期结束后，订阅 $49.99/月 继续接收完整日课 + 前瞻
          </div>
        </>
      ) : (
        <>
          <div style={{ fontSize: 14, color: GD, letterSpacing: 2, marginBottom: 12 }}>
            🔋 解锁澄光日课
          </div>
          <div style={{ fontSize: 13, color: "rgba(0,0,0,0.55)", marginBottom: 20, lineHeight: 1.8 }}>
            每日能量 + 每周前瞻 + 30次问事<br/>
            仅限 $49.99/月 订阅用户
          </div>
        </>
      )}
      <button onClick={onUpgrade} style={{
        padding: "10px 32px",
        background: `linear-gradient(135deg,${GD},#A07828)`,
        border: "none", borderRadius: 8, color: "#fff",
        fontSize: 13, fontWeight: 600, letterSpacing: 1.5,
        cursor: "pointer", boxShadow: "0 3px 12px rgba(139,105,20,0.25)",
      }}>
        {inTrial ? "立即订阅 →" : "订阅 $49.99/月 →"}
      </button>
    </div>
  );
}
